import type { MetricLegajo } from '../../services/projectAutofillDraftService.ts'

export type MetricLegajoDisplayKind = 'spreadsheet' | 'image' | 'pdf' | 'other'

export function classifyMetricLegajoDisplay(legajo: MetricLegajo): MetricLegajoDisplayKind {
  if (legajo.isSpreadsheet) return 'spreadsheet'
  const mime = (legajo.mimeType || '').trim().toLowerCase()
  const name = (legajo.originalName || '').trim().toLowerCase()
  if (mime.startsWith('image/') || /\.(jpe?g|png|gif|webp)$/i.test(name)) return 'image'
  if (
    mime.includes('spreadsheet') ||
    mime.includes('excel') ||
    mime === 'application/vnd.ms-excel' ||
    /\.xlsx?$/i.test(name)
  ) {
    return 'spreadsheet'
  }
  if (mime.includes('pdf') || name.endsWith('.pdf')) return 'pdf'
  if (legajo.pages.length > 0) return 'pdf'
  return 'other'
}

export function metricLegajoPublishHint(
  kind: MetricLegajoDisplayKind,
  legajo: MetricLegajo,
  summarizePages: (pages: number[]) => string
): string {
  const label = legajo.originalName?.trim()
  const namePart = label ? ` (${label})` : ''
  switch (kind) {
    case 'spreadsheet':
      return `Detectamos un cómputo en planilla${namePart}. Al publicar se envía ese archivo.`
    case 'image':
      return `Detectamos un cómputo en imagen${namePart}. Al publicar se envía esa imagen.`
    case 'pdf': {
      const pages = legajo.pages.length > 0 ? summarizePages(legajo.pages) : ''
      return pages
        ? `Detectamos cómputo en el documento${namePart} (páginas ${pages}). Al publicar se envían esas páginas.`
        : `Detectamos cómputo en el documento${namePart}. Al publicar se envía ese archivo.`
    }
    default:
      return `Detectamos cómputo en la documentación${namePart}. Al publicar se envía el archivo asignado.`
  }
}
